import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import React, { useEffect, useState } from "react";

const GTM = ({ fields }) => {
  const code = getFieldValue(fields, "code");

  const gtmScript = `
  <script defer>
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=false;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${code}');
    </script>
  `;
  const gtagScript = `<script defer>    
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${code}');    
    </script>`;
  const noScript = `<!-- Google Tag Manager (noscript) -->
    <iframe src="https://www.googletagmanager.com/ns.html?id=${code}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    <!-- End Google Tag Manager (noscript) -->`;
  const [insertGTMCode, setInsertGTMCode] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && code) {
      let noScriptTags = document.getElementsByTagName("noscript");
      let isCodeExists = false;
      for (let i = 0; i < noScriptTags.length; i++) {
        const e = noScriptTags[i];
        const isGTM =
          e.innerHTML.search("www.googletagmanager.com/ns.html") !== -1;
        const isCode = e.innerHTML.search("id=" + code) !== -1;
        if (isCodeExists === false && isGTM && isCode) {
          isCodeExists = true;
        }
      }

      if (isCodeExists === false) {
        const noscript = document.createElement("noscript");
        noscript.innerHTML = noScript;
        document.body.insertBefore(noscript, document.body.childNodes[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && code) {
      const mainElements = document.getElementsByTagName("main")[0];
      //console.log(mainElements.childNodes);
      if (
        mainElements &&
        mainElements.childNodes &&
        mainElements.childNodes.length > 1
      ) {
        for (const element of mainElements.childNodes) {
          if (element) {
            setInsertGTMCode(true);
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if (insertGTMCode) {
      //console.log({ gtmScript, gtagScript });
      const parsedGtmScript = document
        .createRange()
        .createContextualFragment(gtmScript);
      document.head.appendChild(parsedGtmScript);

      const parsedGtagScript = document
        .createRange()
        .createContextualFragment(gtagScript);
      document.head.appendChild(parsedGtagScript);
    }
  }, [insertGTMCode]);

  return "";
};

export default GTM;
